import { render } from "./foto-17.vue?vue&type=template&id=2040969e&scoped=true"
import script from "./foto-17.vue?vue&type=script&lang=js"
export * from "./foto-17.vue?vue&type=script&lang=js"

import "./foto-17.vue?vue&type=style&index=0&id=2040969e&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2040969e"]])

export default __exports__